import { useState, useEffect } from "react";
import Dashboard from "./Dashboard";
import Login from "./Login";
import "../styles/Admin.css";
export default function Admin() {
  const [auth, setAuth] = useState(null); // null = loading

  useEffect(() => {
    const saved = localStorage.getItem("auth");
    setAuth(saved === "true");
  }, []);

  const handleLogin = (status) => {
    setAuth(status);
    localStorage.setItem("auth", JSON.stringify(status));
  };

  const logout = () => {
    setAuth(false);
    localStorage.removeItem("auth");
  };

  if (auth === null) {
    return (
      <div className="admin-loading">
        Cargando panel...
      </div>
    );
  }

  if (!auth) return <Login onLogin={handleLogin} />;

  return <Dashboard onLogout={logout} />;
}